/* eslint flowtype/require-valid-file-annotation: 0 */ // bca disabled this, do not copy paste OR ELSE

const stripPunctuationAndSpacesRegex = /[\- _,.<>:;+=*&@~\/\|!]*$/;

const smartTruncate = (s, maxLength = 80, suffix = '…') => {
  let truncated;
  if (s.length <= maxLength) {
    return s;
  } else if (s[maxLength - 1] !== ' ' && s[maxLength] === ' ') {
    // this mirrors logic in text_utils.smart_truncate
    truncated = s.substring(0, maxLength);
  } else {
    const truncationIndex = s.lastIndexOf(' ', maxLength);
    truncated = s.substring(0, truncationIndex);
  }

  // strip all trailing punctuation and spaces before applying the suffix
  truncated = truncated.replace(stripPunctuationAndSpacesRegex, '');

  return truncated + suffix;
};

const findMultipleSpacesRegex = /\s\s+/g;

const removeMultipleSpaces = (text) => text.replace(findMultipleSpacesRegex, ' ');

export { smartTruncate, removeMultipleSpaces };
